import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.scss';
import PageLoader from './app/components/stateless/page-loader';
import { DX_ANDROID_APP_LINK, DX_IOS_APP_LINK } from './app/shared/constants';
import { isAndroidDevice, isIosDevice, isMobileDevice } from './app/utility/utility';
// const OnboardingScreen = React.lazy(() => import('./app/screens/onboarding'));
const TncScreen = React.lazy(
  () => import('./app/screens/tnc')
);
const PrivacyPolicyScreen = React.lazy(
  () => import('./app/screens/privacy-policy')
);
const ContactUsScreen = React.lazy(
  () => import('./app/screens/contact-us')
);
const PageNotFound = React.lazy(
  () => import('./app/components/stateless/page-not-found')
);

type RedirectUrlProps = {
  url: string;
  redirectToApps?: boolean;
}

const RedirectUrl = ({ url, redirectToApps = false }: RedirectUrlProps) => {
  React.useEffect(() => {
    if (redirectToApps && isMobileDevice()) {
      if (isAndroidDevice()) {
        window.location.href = DX_ANDROID_APP_LINK;
      } else if (isIosDevice()) {
        window.location.href = DX_IOS_APP_LINK;
      } else {
        window.location.href = url;
      }
    } else {
      window.location.href = url;
    }
  }, [url, redirectToApps]);

  return <h5>Redirecting...</h5>;
};

function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <div className="main-wrapper">
        <div className="app-container">
          <Routes>
            <Route index element={<RedirectUrl url="https://www.dreamsports.group/" redirectToApps />} />
            {/* <Route path="onboarding" element={<OnboardingScreen />} /> */}
            <Route path="/pl/privacy-policy" element={<RedirectUrl url="https://www.pineperks.in/privacyPolicy" />}  />
            <Route path="/pl/tnc" element={<RedirectUrl url="https://www.pineperks.in/termsConditions" />}  />
            <Route
              path="privacy-policy"
              element={<PrivacyPolicyScreen />}
            />
            <Route
              path="tnc"
              element={<TncScreen />}
            />
            <Route
              path="contactus"
              element={<ContactUsScreen />}
            />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    </Suspense>
  );
}

export default App;
